import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { DefaultNamingStrategy } from "../naming-strategy/DefaultNamingStrategy";
import { CannotConnectAlreadyConnectedError, CannotExecuteNotConnectedError, EntityMetadataNotFoundError, QueryRunnerProviderAlreadyReleasedError } from "../error";
import { MigrationExecutor } from "../migration/MigrationExecutor";
import { EntityMetadataValidator } from "../metadata-builder/EntityMetadataValidator";
import { EntityManagerFactory } from "../entity-manager/EntityManagerFactory";
import { DriverFactory } from "../driver/DriverFactory";
import { ConnectionMetadataBuilder } from "../connection/ConnectionMetadataBuilder";
import { SelectQueryBuilder } from "../query-builder/SelectQueryBuilder";
import { LoggerFactory } from "../logger/LoggerFactory";
import { QueryResultCacheFactory } from "../cache/QueryResultCacheFactory";
import { RelationLoader } from "../query-builder/RelationLoader";
import { ObjectUtils } from "../util/ObjectUtils";
import { TypeORMError } from "../error";
import { RelationIdLoader } from "../query-builder/RelationIdLoader";
import { DriverUtils } from "../driver/DriverUtils";
import { InstanceChecker } from "../util/InstanceChecker";
/**
 * DataSource is a pre-defined connection configuration to a specific database.
 * You can have multiple data sources connected (with multiple connections in it),
 * connected to multiple databases in your application.
 *
 * Before, it was called `Connection`, but now `Connection` is deprecated
 * because `Connection` isn't the best name for what it's actually is.
 */
export var DataSource = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function DataSource(options) {
    _classCallCheck(this, DataSource);
    this["@instanceof"] = Symbol.for("DataSource");
    /**
     * Migration instances that are registered for this connection.
     */
    this.migrations = [];
    /**
     * Entity subscriber instances that are registered for this connection.
     */
    this.subscribers = [];
    /**
     * All entity metadatas that are registered for this connection.
     */
    this.entityMetadatas = [];
    this.name = options.name || "default";
    this.options = options;
    this.logger = new LoggerFactory().create(this.options.logger, this.options.logging);
    this.driver = new DriverFactory().create(this);
    this.manager = this.createEntityManager();
    this.namingStrategy = options.namingStrategy || new DefaultNamingStrategy();
    this.metadataTableName = options.metadataTableName || "typeorm_metadata";
    this.queryResultCache = options.cache ? new QueryResultCacheFactory(this).create() : undefined;
    this.relationLoader = new RelationLoader(this);
    this.relationIdLoader = new RelationIdLoader(this);
    this.isInitialized = false;
  }
  // -------------------------------------------------------------------------
  // Public Accessors
  // -------------------------------------------------------------------------
  /**
   Indicates if DataSource is initialized or not.
   *
   * @deprecated use .isInitialized instead
   */
  _createClass(DataSource, [{
    key: "isConnected",
    get: function get() {
      return this.isInitialized;
    }
    /**
     * Gets the mongodb entity manager that allows to perform mongodb-specific repository operations
     * with any entity in this connection.
     *
     * Available only in mongodb connections.
     */
  }, {
    key: "mongoManager",
    get: function get() {
      if (!InstanceChecker.isMongoEntityManager(this.manager)) throw new TypeORMError("MongoEntityManager is only available for MongoDB databases.");
      return this.manager;
    }
    /**
     * Gets a sql.js specific Entity Manager that allows to perform special load and save operations
     *
     * Available only in connection with the sqljs driver.
     */
  }, {
    key: "sqljsManager",
    get: function get() {
      if (!InstanceChecker.isSqljsEntityManager(this.manager)) throw new TypeORMError("SqljsEntityManager is only available for Sqljs databases.");
      return this.manager;
    }
    // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
    /**
     * Updates current connection options with provided options.
     */
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      Object.assign(this.options, options);
      if (options.logger || options.logging) {
        this.logger = new LoggerFactory().create(options.logger || this.options.logger, options.logging || this.options.logging);
      }
      if (options.namingStrategy) {
        this.namingStrategy = options.namingStrategy;
      }
      if (options.cache) {
        this.queryResultCache = new QueryResultCacheFactory(this).create();
      }
      return this;
    }
    /**
     * Performs connection to the database.
     * This method should be called once on application bootstrap.
     * This method not necessarily creates database connection (depend on database type),
     * but it also can setup a connection pool with database to use.
     */
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.isInitialized) {
                _context.next = 2;
                break;
              }
              throw new CannotConnectAlreadyConnectedError(this.name);
            case 2:
              _context.next = 4;
              return this.driver.connect();
            case 4:
              if (!this.queryResultCache) {
                _context.next = 7;
                break;
              }
              _context.next = 7;
              return this.queryResultCache.connect();
            case 7:
              // set connected status for the current connection
              ObjectUtils.assign(this, {
                isInitialized: true
              });
              _context.prev = 8;
              _context.next = 11;
              return this.buildMetadatas();
            case 11:
              _context.next = 13;
              return this.driver.afterConnect();
            case 13:
              if (!this.options.dropSchema) {
                _context.next = 16;
                break;
              }
              _context.next = 16;
              return this.dropDatabase();
            case 16:
              if (!this.options.migrationsRun) {
                _context.next = 19;
                break;
              }
              _context.next = 19;
              return this.runMigrations({
                transaction: this.options.migrationsTransactionMode
              });
            case 19:
              if (!this.options.synchronize) {
                _context.next = 22;
                break;
              }
              _context.next = 22;
              return this.synchronize();
            case 22:
              _context.next = 29;
              break;
            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](8);
              _context.next = 28;
              return this.close();
            case 28:
              throw _context.t0;
            case 29:
              return _context.abrupt("return", this);
            case 30:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[8, 24]]);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
    /**
     * Performs connection to the database.
     * This method should be called once on application bootstrap.
     * This method not necessarily creates database connection (depend on database type),
     * but it also can setup a connection pool with database to use.
     *
     * @deprecated use .initialize method instead
     */
  }, {
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.initialize());
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function connect() {
        return _connect.apply(this, arguments);
      }
      return connect;
    }()
    /**
     * Closes connection with the database.
     * Once connection is closed, you cannot use repositories or perform any operations except opening connection again.
     */
  }, {
    key: "destroy",
    value: function () {
      var _destroy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.isInitialized) {
                _context3.next = 2;
                break;
              }
              throw new CannotExecuteNotConnectedError(this.name);
            case 2:
              _context3.next = 4;
              return this.driver.disconnect();
            case 4:
              if (!this.queryResultCache) {
                _context3.next = 7;
                break;
              }
              _context3.next = 7;
              return this.queryResultCache.disconnect();
            case 7:
              ObjectUtils.assign(this, {
                isInitialized: false
              });
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function destroy() {
        return _destroy.apply(this, arguments);
      }
      return destroy;
    }()
    /**
     * Closes connection with the database.
     * Once connection is closed, you cannot use repositories or perform any operations except opening connection again.
     *
     * @deprecated use .destroy method instead
     */
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.destroy());
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function close() {
        return _close.apply(this, arguments);
      }
      return close;
    }()
    /**
     * Creates database schema for all entities registered in this connection.
     * Can be used only after connection to the database is established.
     *
     * @param dropBeforeSync If set to true then it drops the database with all its tables and data
     */
  }, {
    key: "synchronize",
    value: function () {
      var _synchronize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var dropBeforeSync,
          schemaBuilder,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              dropBeforeSync = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : false;
              if (this.isInitialized) {
                _context5.next = 3;
                break;
              }
              throw new CannotExecuteNotConnectedError(this.name);
            case 3:
              if (!dropBeforeSync) {
                _context5.next = 6;
                break;
              }
              _context5.next = 6;
              return this.dropDatabase();
            case 6:
              schemaBuilder = this.driver.createSchemaBuilder();
              _context5.next = 9;
              return schemaBuilder.build();
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function synchronize() {
        return _synchronize.apply(this, arguments);
      }
      return synchronize;
    }()
    /**
     * Drops the database and all its data.
     * Be careful with this method on production since this method will erase all your database tables and their data.
     * Can be used only after connection to the database is established.
     */
    // TODO rename
  }, {
    key: "dropDatabase",
    value: function () {
      var _dropDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var queryRunner, databases, _iterator, _step, database;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              queryRunner = this.createQueryRunner();
              _context6.prev = 1;
              if (!(this.driver.options.type === "mssql" || DriverUtils.isMySQLFamily(this.driver) || this.driver.options.type === "aurora-mysql" || DriverUtils.isSQLiteFamily(this.driver))) {
                _context6.next = 30;
                break;
              }
              databases = [];
              this.entityMetadatas.forEach(function (metadata) {
                if (metadata.database && databases.indexOf(metadata.database) === -1) databases.push(metadata.database);
              });
              if (databases.length === 0 && this.driver.database) {
                databases.push(this.driver.database);
              }
              if (!(databases.length === 0)) {
                _context6.next = 11;
                break;
              }
              _context6.next = 9;
              return queryRunner.clearDatabase();
            case 9:
              _context6.next = 28;
              break;
            case 11:
              _iterator = _createForOfIteratorHelper(databases);
              _context6.prev = 12;
              _iterator.s();
            case 14:
              if ((_step = _iterator.n()).done) {
                _context6.next = 20;
                break;
              }
              database = _step.value;
              _context6.next = 18;
              return queryRunner.clearDatabase(database);
            case 18:
              _context6.next = 14;
              break;
            case 20:
              _context6.next = 25;
              break;
            case 22:
              _context6.prev = 22;
              _context6.t0 = _context6["catch"](12);
              _iterator.e(_context6.t0);
            case 25:
              _context6.prev = 25;
              _iterator.f();
              return _context6.finish(25);
            case 28:
              _context6.next = 32;
              break;
            case 30:
              _context6.next = 32;
              return queryRunner.clearDatabase();
            case 32:
              _context6.prev = 32;
              _context6.next = 35;
              return queryRunner.release();
            case 35:
              return _context6.finish(32);
            case 36:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1,, 32, 36], [12, 22, 25, 28]]);
      }));
      function dropDatabase() {
        return _dropDatabase.apply(this, arguments);
      }
      return dropDatabase;
    }()
    /**
     * Runs all pending migrations.
     * Can be used only after connection to the database is established.
     */
  }, {
    key: "runMigrations",
    value: function () {
      var _runMigrations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(options) {
        var migrationExecutor, successMigrations;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (this.isInitialized) {
                _context7.next = 2;
                break;
              }
              throw new CannotExecuteNotConnectedError(this.name);
            case 2:
              migrationExecutor = new MigrationExecutor(this);
              migrationExecutor.transaction = options && options.transaction || "all";
              migrationExecutor.fake = options && options.fake || false;
              _context7.next = 7;
              return migrationExecutor.executePendingMigrations();
            case 7:
              successMigrations = _context7.sent;
              return _context7.abrupt("return", successMigrations);
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function runMigrations(_x) {
        return _runMigrations.apply(this, arguments);
      }
      return runMigrations;
    }()
    /**
     * Reverts last executed migration.
     * Can be used only after connection to the database is established.
     */
  }, {
    key: "undoLastMigration",
    value: function () {
      var _undoLastMigration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(options) {
        var migrationExecutor;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (this.isInitialized) {
                _context8.next = 2;
                break;
              }
              throw new CannotExecuteNotConnectedError(this.name);
            case 2:
              migrationExecutor = new MigrationExecutor(this);
              migrationExecutor.transaction = options && options.transaction || "all";
              migrationExecutor.fake = options && options.fake || false;
              _context8.next = 7;
              return migrationExecutor.undoLastMigration();
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function undoLastMigration(_x2) {
        return _undoLastMigration.apply(this, arguments);
      }
      return undoLastMigration;
    }()
    /**
     * Lists all migrations and whether they have been run.
     * Returns true if there are pending migrations
     */
  }, {
    key: "showMigrations",
    value: function () {
      var _showMigrations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var migrationExecutor;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (this.isInitialized) {
                _context9.next = 2;
                break;
              }
              throw new CannotExecuteNotConnectedError(this.name);
            case 2:
              migrationExecutor = new MigrationExecutor(this);
              _context9.next = 5;
              return migrationExecutor.showMigrations();
            case 5:
              return _context9.abrupt("return", _context9.sent);
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function showMigrations() {
        return _showMigrations.apply(this, arguments);
      }
      return showMigrations;
    }()
    /**
     * Checks if entity metadata exist for the given entity class, target name or table name.
     */
  }, {
    key: "hasMetadata",
    value: function hasMetadata(target) {
      return !!this.findMetadata(target);
    }
    /**
     * Gets entity metadata for the given entity class or schema name.
     */
  }, {
    key: "getMetadata",
    value: function getMetadata(target) {
      var metadata = this.findMetadata(target);
      if (!metadata) throw new EntityMetadataNotFoundError(target);
      return metadata;
    }
    /**
     * Gets repository for the given entity.
     */
  }, {
    key: "getRepository",
    value: function getRepository(target) {
      return this.manager.getRepository(target);
    }
    /**
     * Gets tree repository for the given entity class or name.
     * Only tree-type entities can have a TreeRepository, like ones decorated with @Tree decorator.
     */
  }, {
    key: "getTreeRepository",
    value: function getTreeRepository(target) {
      return this.manager.getTreeRepository(target);
    }
    /**
     * Gets mongodb-specific repository for the given entity class or name.
     * Works only if connection is mongodb-specific.
     */
  }, {
    key: "getMongoRepository",
    value: function getMongoRepository(target) {
      if (!(this.driver.options.type === "mongodb")) throw new TypeORMError("You can use getMongoRepository only for MongoDB connections.");
      return this.manager.getRepository(target);
    }
    /**
     * Gets custom entity repository marked with @EntityRepository decorator.
     *
     * @deprecated use Repository.extend function to create a custom repository
     */
  }, {
    key: "getCustomRepository",
    value: function getCustomRepository(customRepository) {
      return this.manager.getCustomRepository(customRepository);
    }
  }, {
    key: "transaction",
    value: function () {
      var _transaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(isolationOrRunInTransaction, runInTransactionParam) {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", this.manager.transaction(isolationOrRunInTransaction, runInTransactionParam));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function transaction(_x3, _x4) {
        return _transaction.apply(this, arguments);
      }
      return transaction;
    }()
    /**
     * Executes raw SQL query and returns raw database results.
     */
  }, {
    key: "query",
    value: function () {
      var _query2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(_query, parameters, queryRunner) {
        var usedQueryRunner;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!InstanceChecker.isMongoEntityManager(this.manager)) {
                _context11.next = 2;
                break;
              }
              throw new TypeORMError("Queries aren't supported by MongoDB.");
            case 2:
              if (!(queryRunner && queryRunner.isReleased)) {
                _context11.next = 4;
                break;
              }
              throw new QueryRunnerProviderAlreadyReleasedError();
            case 4:
              usedQueryRunner = queryRunner || this.createQueryRunner();
              _context11.prev = 5;
              _context11.next = 8;
              return usedQueryRunner.query(_query, parameters);
            case 8:
              return _context11.abrupt("return", _context11.sent);
            case 9:
              _context11.prev = 9;
              if (queryRunner) {
                _context11.next = 13;
                break;
              }
              _context11.next = 13;
              return usedQueryRunner.release();
            case 13:
              return _context11.finish(9);
            case 14:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this, [[5,, 9, 14]]);
      }));
      function query(_x5, _x6, _x7) {
        return _query2.apply(this, arguments);
      }
      return query;
    }()
    /**
     * Creates a new query builder that can be used to build a SQL query.
     */
  }, {
    key: "createQueryBuilder",
    value: function createQueryBuilder(entityOrRunner, alias, queryRunner) {
      if (InstanceChecker.isMongoEntityManager(this.manager)) throw new TypeORMError("Query Builder is not supported by MongoDB.");
      if (alias) {
        alias = DriverUtils.buildAlias(this.driver, alias);
        var metadata = this.getMetadata(entityOrRunner);
        return new SelectQueryBuilder(this, queryRunner).select(alias).from(metadata.target, alias);
      } else {
        return new SelectQueryBuilder(this, entityOrRunner);
      }
    }
    /**
     * Creates a query runner used for perform queries on a single database connection.
     * Using query runners you can control your queries to execute using single database connection and
     * manually control your database transaction.
     *
     * Mode is used in replication mode and indicates whatever you want to connect
     * to master database or any of slave databases.
     * If you perform writes you must use master database,
     * if you perform reads you can use slave databases.
     */
  }, {
    key: "createQueryRunner",
    value: function createQueryRunner() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "master";
      var queryRunner = this.driver.createQueryRunner(mode);
      var manager = this.createEntityManager(queryRunner);
      Object.assign(queryRunner, {
        manager: manager
      });
      return queryRunner;
    }
    /**
     * Gets entity metadata of the junction table (many-to-many table).
     */
  }, {
    key: "getManyToManyMetadata",
    value: function getManyToManyMetadata(entityTarget, relationPropertyPath) {
      var relationMetadata = this.getMetadata(entityTarget).findRelationWithPropertyPath(relationPropertyPath);
      if (!relationMetadata) throw new TypeORMError("Relation \"".concat(relationPropertyPath, "\" was not found in ").concat(entityTarget, " entity."));
      if (!relationMetadata.isManyToMany) throw new TypeORMError("Relation \"".concat(entityTarget, "#").concat(relationPropertyPath, "\" does not have a many-to-many relationship.") + "You can use this method only on many-to-many relations.");
      return relationMetadata.junctionEntityMetadata;
    }
    /**
     * Creates an Entity Manager for the current connection with the help of the EntityManagerFactory.
     */
  }, {
    key: "createEntityManager",
    value: function createEntityManager(queryRunner) {
      return new EntityManagerFactory().create(this, queryRunner);
    }
    // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Finds exist entity metadata by the given entity class, target name or table name.
     */
  }, {
    key: "findMetadata",
    value: function findMetadata(target) {
      return this.entityMetadatas.find(function (metadata) {
        if (metadata.target === target) return true;
        if (InstanceChecker.isEntitySchema(target)) {
          return metadata.name === target.options.name;
        }
        if (typeof target === "string") {
          if (target.indexOf(".") !== -1) {
            return metadata.tablePath === target;
          } else {
            return metadata.name === target || metadata.tableName === target;
          }
        }
        if (ObjectUtils.isObject(target) && typeof target.name === "string") {
          if (target.name.indexOf(".") !== -1) {
            return metadata.tablePath === target.name;
          } else {
            return metadata.name === target.name || metadata.tableName === target.name;
          }
        }
        return false;
      });
    }
    /**
     * Builds metadatas for all registered classes inside this connection.
     */
  }, {
    key: "buildMetadatas",
    value: function () {
      var _buildMetadatas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var connectionMetadataBuilder, entityMetadataValidator, flattenedSubscribers, subscribers, flattenedEntities, entityMetadatas, flattenedMigrations, migrations, _iterator2, _step2, entityMetadata;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              connectionMetadataBuilder = new ConnectionMetadataBuilder(this);
              entityMetadataValidator = new EntityMetadataValidator(); // create subscribers instances if they are not disallowed from high-level (for example they can disallowed from migrations run process)
              flattenedSubscribers = ObjectUtils.mixedListToArray(this.options.subscribers || []);
              _context12.next = 5;
              return connectionMetadataBuilder.buildSubscribers(flattenedSubscribers);
            case 5:
              subscribers = _context12.sent;
              ObjectUtils.assign(this, {
                subscribers: subscribers
              });
              // build entity metadatas
              flattenedEntities = ObjectUtils.mixedListToArray(this.options.entities || []);
              _context12.next = 10;
              return connectionMetadataBuilder.buildEntityMetadatas(flattenedEntities);
            case 10:
              entityMetadatas = _context12.sent;
              ObjectUtils.assign(this, {
                entityMetadatas: entityMetadatas
              });
              // create migration instances
              flattenedMigrations = ObjectUtils.mixedListToArray(this.options.migrations || []);
              _context12.next = 15;
              return connectionMetadataBuilder.buildMigrations(flattenedMigrations);
            case 15:
              migrations = _context12.sent;
              ObjectUtils.assign(this, {
                migrations: migrations
              });
              // validate all created entity metadatas to make sure user created entities are valid and correct
              entityMetadataValidator.validateMany(this.entityMetadatas.filter(function (metadata) {
                return metadata.tableType !== "view";
              }), this.driver);
              // set current data source to the entities
              _iterator2 = _createForOfIteratorHelper(entityMetadatas);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  entityMetadata = _step2.value;
                  if (InstanceChecker.isBaseEntityConstructor(entityMetadata.target)) {
                    entityMetadata.target.useDataSource(this);
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            case 20:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function buildMetadatas() {
        return _buildMetadatas.apply(this, arguments);
      }
      return buildMetadatas;
    }()
  }]);
  return DataSource;
}();